import React from 'react';
import ServicesPageContainer from './services.styles';
import ServiceBox from './../../components/service-box/service-box.component';
import MainHeading from '../../components/main-heading/main-heading.component';
import Container from './../../components/container/container.component';

const ServicesPage = () => {
    return (
        <ServicesPageContainer id="Services">
            <Container>
                <div className="container">
                    <MainHeading title="Services" />
                    <div className="services-container">
                        <ServiceBox
                            iconName="fas fa-desktop fa-3x"
                            text="Vorem amet intuitive"
                            description="Curabitur arcu erat, accumsan id imperdiet et,
                    porttitor at sem. Mauris blandit aliquet elit,
                    eget tincidunt nibh pulvinar a. Curabitur
                    aliquet quam."
                        />
                        <ServiceBox
                            iconName="fas fa-cog fa-3x"
                            text="Vorem amet intuitive"
                            description="Curabitur arcu erat, accumsan id imperdiet et,
                    porttitor at sem. Mauris blandit aliquet elit,
                    eget tincidunt nibh pulvinar a. Curabitur
                    aliquet quam."
                        />
                        <ServiceBox
                            iconName="fas fa-pencil-ruler fa-3x"
                            text="Vorem amet intuitive"
                            description="Curabitur arcu erat, accumsan id imperdiet et,
                    porttitor at sem. Mauris blandit aliquet elit,
                    eget tincidunt nibh pulvinar a. Curabitur
                    aliquet quam."
                        />
                        <ServiceBox
                            iconName="fas fa-camera fa-3x"
                            text="Vorem amet intuitive"
                            description="Curabitur arcu erat, accumsan id imperdiet et,
                    porttitor at sem. Mauris blandit aliquet elit,
                    eget tincidunt nibh pulvinar a. Curabitur
                    aliquet quam."
                        />
                    </div>
                </div>
            </Container>
        </ServicesPageContainer>
    );
};

export default ServicesPage;
